/* eslint-disable no-unused-vars */
import { DeviceList, ICartInput } from "./api";
export interface ICourseCartInput extends ICartInput {
  is_buyBasket?: boolean;
}
export type SafeNumber = number | `${number}`;
export type IHeaderTypes = {
  name: string;
  id: number | "all";
};
export type ITabItemTypes = {
  id: number | "all";
  items: ICourseCartInput[];
};
export interface ITabListInput {
  title: string;
  headerItems: IHeaderTypes[];
  currentTabItem: ITabItemTypes[];
  onChange: (id: number | "all") => void;
  id: string;
  slug: PRODUCT_SLUG;
  parameter?: {
    status?: string;
    orderby?: string;
    is_free?: boolean;
  };
  actionProduct?(e: ICartInput): Promise<boolean>;
  favoriteAction?(
    e: number,
    is_favorite: boolean,
    title: string
  ): Promise<boolean>;
}

export interface ISwiperInput {
  title?: string;
  items: ICourseCartInput[] | [];
  parameter?: {
    status?: string;
    orderby?: string;
    is_free?: boolean | string;
    instructor_ids?: string;
  };
  id: string;
  actionProduct?(e: ICartInput): Promise<boolean>;
  favoriteAction?(
    e: number,
    is_favorite: boolean,
    title: string
  ): Promise<boolean>;
  slug: string;
}

export interface IToastInput {
  mode: "danger" | "success" | "warning" | "info" | "default";
  textBody: string;
}

type ResultInput = {
  content: string;
  contentNoFormatting: string;
  contextUrl: string;
  fileFormat: string;
  image?: {
    height: number;
    url: string;
    width: number;
  };
  perResultLabels?: Array<{
    anchor: string;
    label: string;
    labelWithOp: string;
  }>;
  richSnippet: {
    metatags: {
      handheldfriendly: boolean;
      msapplicationTilecolor: string;
      nextHeadCount: string;
      ogDescription: string;
      ogImage: string;
      ogImageAlt: string;
      ogImageHeight: string;
      ogImageSecureUrl: string;
      ogImageWidth: string;
      ogLocale: string;
      ogSiteName: string;
      ogTitle: string;
      ogType: string;
      ogUrl: string;
      themeColor: string;
      twitterCard: string;
      twitterDescription: string;
      twitterDomain: string;
      twitterImage: string;
      twitterSite: string;
      twitterTitle: string;
      twitterUrl: string;
      viewport: string;
    };
  };
  thumbnailImage: {
    height: number;
    url: string;
    width: number;
  };
  title: string;
  titleNoFormatting: string;
  url: string;
  visibleUrl: string;
};
export interface IGoogleResultInput extends Array<ResultInput> {}

export enum PRODUCT_SLUG {
  MOST_RATE_PRODUCT_MONETARY = "mostRateProductMonetary",
  NEW_PRODUCT_MONETARY = "newProductMonetary",
  MOST_RATE_PRODUCT_FREE = "mostRateProductFree",
  NEW_PRODUCT_FREE = "newProductFree",
  USER_FAVORITE_PRODUCTS = "userFavoriteProducts",
  USER_RECOMMENDED_PRODUCTS = "recommendedProducts",
  WEBINAR_PRODUCTS = "webinarProducts",
  WAIT_FOR_PUBLISH_PRODUCT = "waitForPublishProduct",
  USER_RECENT_VIEW_PRODUCT = "userRecentViewProduct",
  BLOG_FARADARS = "blog_faradars",
  MOST_RATE_PRODUCT_MONETARY_LANGUAGE = "mostRateProductMonetaryLanguage",
  MOST_RATE_PRODUCT_MONETARY_ENGINEERING = "mostRateProductMonetaryEngineering",
  MOST_RATE_PRODUCT_MONETARY_PROGRAMMING = "mostRateProductMonetaryProgramming",
  MOST_RATE_PRODUCT_MONETARY_AI = "mostRateProductMonetaryAi",
  RELATED_PRODUCTS = "relatedProducts",
}

export const FAVORITE_LIMIT_HOME_SLIDER = 5;

export const eventActionTitles = {
  [PRODUCT_SLUG.MOST_RATE_PRODUCT_MONETARY]: "View a popular course",
  [PRODUCT_SLUG.NEW_PRODUCT_MONETARY]: "View a recent course",
  [PRODUCT_SLUG.MOST_RATE_PRODUCT_FREE]: "View a free popular course",
  [PRODUCT_SLUG.NEW_PRODUCT_FREE]: "View a free course",
  [PRODUCT_SLUG.USER_FAVORITE_PRODUCTS]: "",
  [PRODUCT_SLUG.USER_RECOMMENDED_PRODUCTS]: "View a recommended course",
  [PRODUCT_SLUG.WEBINAR_PRODUCTS]: "View a webinar",
  [PRODUCT_SLUG.WAIT_FOR_PUBLISH_PRODUCT]: "View an upcoming course",
  [PRODUCT_SLUG.USER_RECENT_VIEW_PRODUCT]: "",
  [PRODUCT_SLUG.BLOG_FARADARS]: "View blog faradars",
  [PRODUCT_SLUG.MOST_RATE_PRODUCT_MONETARY_LANGUAGE]:
    "View a language popular course",
  [PRODUCT_SLUG.MOST_RATE_PRODUCT_MONETARY_ENGINEERING]:
    "View a engineering popular course",
  [PRODUCT_SLUG.MOST_RATE_PRODUCT_MONETARY_PROGRAMMING]:
    "View a programming popular course",
};

export const homeSlidersTitle = {
  [PRODUCT_SLUG.MOST_RATE_PRODUCT_MONETARY]: "پرمخاطب‌ترین آموزش‌های ",
  [PRODUCT_SLUG.NEW_PRODUCT_MONETARY]: "جدیدترین آموزش‌های ",
  [PRODUCT_SLUG.MOST_RATE_PRODUCT_FREE]: "پرمخاطب‌ترین آموزش‌های رایگان ",
  [PRODUCT_SLUG.NEW_PRODUCT_FREE]: "جدیدترین آموزش‌های رایگان ",
  [PRODUCT_SLUG.USER_FAVORITE_PRODUCTS]: "",
  [PRODUCT_SLUG.USER_RECOMMENDED_PRODUCTS]: "",
  [PRODUCT_SLUG.WEBINAR_PRODUCTS]: "",
  [PRODUCT_SLUG.WAIT_FOR_PUBLISH_PRODUCT]: "آموزش‌های در دست انتشار ",
  [PRODUCT_SLUG.USER_RECENT_VIEW_PRODUCT]: "",
  [PRODUCT_SLUG.BLOG_FARADARS]: "مجله فرادرس",
  [PRODUCT_SLUG.MOST_RATE_PRODUCT_MONETARY_LANGUAGE]: "پرمخاطب‌ترین آموزش‌های ",
  [PRODUCT_SLUG.MOST_RATE_PRODUCT_MONETARY_ENGINEERING]:
    "پرمخاطب‌ترین آموزش‌های ",
  [PRODUCT_SLUG.MOST_RATE_PRODUCT_MONETARY_PROGRAMMING]:
    "پرمخاطب‌ترین آموزش‌های ",
  [PRODUCT_SLUG.MOST_RATE_PRODUCT_MONETARY_AI]:
    "پرمخاطب‌ترین آموزش‌های هوش مصنوعی",
  [PRODUCT_SLUG.RELATED_PRODUCTS]: "پیشنهادی برای شما",
};

export enum STATUS {
  PUBLISHING = "publishing",
  EDITING = "editing",
  RECORDING = "recording",
  START_RECORDING = "start_recording",
  PLANNING = "planning",
  UNPUBLISHED = "unPublished",
  PUBLISHED = "published",
  QUALITY_INSPECTION = "quality_inspection",
}

export enum DEGREE {
  MSS = "mss",
  MS = "ms",
  PHD = "phd",
  PHD_S = "phds",
  BS = "bs",
  BSS = "bss",
}

export const instructorsDegreesTitle = {
  [DEGREE.MSS]: "دانشجوی کارشناسی ارشد",
  [DEGREE.BSS]: "دانشجوی کارشناسی",
  [DEGREE.BS]: "کارشناسی",
  [DEGREE.MS]: "کارشناسی ارشد",
  [DEGREE.PHD]: "دکتری تخصصی",
  [DEGREE.PHD_S]: "دانشجوی دکتری تخصصی",
};

export const instructorsDegreeTitlePrefix: { [key: string]: string } = {
  dr: "دکتر ",
};

export enum WEBINAR_STATUS {
  REGISTRATION = "registration",
  END = "end",
  START = "start",
  PUBLISHED = "published",
}

export interface DevicesList extends DeviceList {
  hasLogout: boolean;
}

export enum DEVICE_TYPE {
  IPAD = "ipad",
  IOS = "ios",
  ANDROID = "android",
  WINDOWS = "windows",
  LINUX = "linux",
  MAC = "mac",
  DEFAULT = "default",
}

export enum FEEDBACK_STEP {
  REPORT = "report",
  SUGGESTION = "suggestion",
  DEFAULT = "default",
  SUCCESS = "success",
}
